module.exports = __webpack_public_path__ + "static/media/the-moms-co.79dc2970.png";